"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitPage = void 0;
// tslint:disable:no-var-requires
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
require("./SplitPage.scss");
var NewsComponent_1 = require("@app/features/news/components/NewsComponent");
var SplitPage = function (props) { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_helmet_1.Helmet, { title: props.title }),
    react_1.default.createElement("div", { className: "split-page" },
        react_1.default.createElement("div", { className: "split-page-container" },
            react_1.default.createElement("div", { className: "columns is-gapless main-content" },
                react_1.default.createElement("div", { className: "column column-left" },
                    react_1.default.createElement(NewsComponent_1.NewsComponent, null)),
                react_1.default.createElement("div", { className: "column column-right" }, props.children)))))); };
exports.SplitPage = SplitPage;
